import { useContext } from 'react'
import { useNavigate } from 'react-router-dom'
import { Helmet } from 'react-helmet'
import ManagersContext from '../../containers/ManagersContext'
import funride from '../../lib/funride/funride.module.less'
interface iInnerClientSplashProps {
  client: string
}

export default function InnerClientSplash (props:iInnerClientSplashProps) {
  const {objPortfolio, objResume} = useContext(ManagersContext)
  const clientObj = objPortfolio.clients[props.client]
  const position = objResume.resume.getPosition(props.client)
  const engagementDetails = position?.engagementDetails ? position.engagementDetails : ''
  const navigate = useNavigate()

  return (
    <>
      <Helmet>
        <title>Greg Sandell Portfolio - {props.client}</title>
      </Helmet>
      <div className='portfolioDisplay'>
        <header>
          <h1>{clientObj.client}</h1>
          <p dangerouslySetInnerHTML={{ __html: engagementDetails }} />
        </header>
        <div>
          <div  style={{cursor: 'pointer'}}
            onClick={() => { navigate(`/portfolio/${props.client}/gallery`) }}>
            <img
              src={require('' + clientObj.image)} width={clientObj.width} // quote is necessary for some reason
              height={clientObj.height} />
          </div>
          <p className={funride.clickForMore}>(Click image for more detail)</p>
        </div>
      </div>
    </>
  )
}
